<template>
  <div class="animated fadeIn">
    <b-card>
      <div slot="header">
        Master Item Form
        <div class="card-header-actions">
          <button
            v-if="saveEnabled"
            class="btn btn-primary mr-1"
            @click.stop="save()"
          >
            <i class="fa fa-save"></i> Save
          </button>
          <b-button class="btn btn-danger mr-1" @click="close()">
            <i class="fa fa-close"></i> Close</b-button
          >
        </div>
      </div>
      <b-form>
        <b-row>
          <b-col lg="6">
            <b-form-group label-cols-md="2" label="Item Name">
              <b-form-input
                v-model="model.itemname"
                :state="!$v.model.itemname.$error"
              ></b-form-input>
            </b-form-group>
            <b-form-group label-cols-md="2" label="Item Code">
              <b-row>
                <b-col lg="5">
                  <b-form-input
                    v-model="model.partnumber"
                    placeholder="Part Number/SKU"
                    v-b-tooltip.hover
                    title="International Code: Part Number, EMPTY for AUTO NUMBERING"
                  ></b-form-input>
                </b-col>
                <b-col lg="7">
                  <b-input-group>
                    <b-form-checkbox
                      style="font-size: smaller"
                      class="ml-1 mt-2"
                      v-model="model.isactive"
                      value="0"
                      unchecked-value="1"
                    >
                      Inactive
                    </b-form-checkbox>
                    <b-form-checkbox
                      style="font-size: smaller"
                      class="ml-2 mt-2"
                      v-model="model.isexpireable"
                      value="1"
                      unchecked-value="0"
                    >
                      Has Expired Date
                    </b-form-checkbox>
                  </b-input-group>
                </b-col>
              </b-row>
            </b-form-group>

            <b-form-group label-cols-md="2" label="Item Category">
              <b-form-select
                v-model="model.itemcategory"
                :state="!$v.model.itemcategory.$error"
                :plain="true"
                :options="itemCategories"
              ></b-form-select>
            </b-form-group>

            <b-form-group label-cols-md="2" label="Purchase Price">
              <b-row>
                <b-col class="pr-1" cols="4">
                  <my-number
                    class="form-control text-right"
                    v-model="model.unitcost"
                    :precision="2"
                  ></my-number>
                </b-col>
                <b-col class="pl-1" cols="8">
                  <b-input-group>
                    <b-input-group-prepend
                      ><span class="p-2"
                        >Sale Price</span
                      ></b-input-group-prepend
                    >
                    <my-number
                      class="form-control text-right"
                      v-model="model.unitprice"
                      :precision="2"
                    ></my-number>
                  </b-input-group>
                </b-col>
              </b-row>
            </b-form-group>
            <b-form-group label-cols-md="2" label="Unit Size">
              <b-row>
                <b-col class="pr-1" cols="4">
                  <b-form-input
                    v-model="model.unitsize"
                    :state="!$v.model.unitsize.$error"
                  ></b-form-input>
                </b-col>
                <!-- <b-col class="pl-1" cols="8">
                  <b-input-group>
                    <b-input-group-prepend
                      ><span class="p-2">Inventory</span></b-input-group-prepend
                    >
                    <b-form-select
                      v-model="model.inventory"
                      :plain="true"
                      :options="dataList.YesNo"
                    ></b-form-select>
                    <b-input-group-prepend
                      ><span class="p-2">
                        Inv.UnitSize</span
                      ></b-input-group-prepend
                    >
                    <b-form-input
                      v-model="model.qtykonversi"
                      placeholder="Qty Conversion"
                      type="number"
                      min="1"
                      v-b-tooltip.hover
                      title="QTY Conversion Purchase to Inventory Unitsize"
                    ></b-form-input>
                    <b-form-input
                      v-model="model.invunitom"
                      :state="!$v.model.invunitom.$error"
                    ></b-form-input>
                  </b-input-group>
                </b-col> -->
              </b-row>
            </b-form-group>
          </b-col>
          <b-col lg="6">
            <h5>Supplier/vendor</h5>
            <b-table
              class="mb-0"
              ref="tblVendor"
              outlined
              striped
              hover
              small
              style="font-size: smaller"
              :items="vendor.list"
              :fields="vendor.fields"
              :current-page="vendor.page"
              :per-page="vendor.limit"
            >
              <template v-slot:cell(index)="data">
                {{ data.index + 1 }}
              </template>

              <template v-slot:cell(action)="data">
                <div class="text-center">
                  <a
                    href="javascript:void(0)"
                    class="text-danger"
                    @click="delVendor(data.index)"
                  >
                    <i class="fa fa-trash"></i>
                  </a>
                </div>
              </template>
            </b-table>
            <b-row>
              <b-col cols="6">
                <b-row>
                  <b-button
                    size="sm"
                    class="btn btn-primary ml-3"
                    @click="addVendor"
                    >Add Supplier/vendor</b-button
                  >
                  <div class="ml-2">
                    Showing
                    {{ (vendor.page - 1) * vendor.limit + 1 }}
                    to
                    {{ vendor.page * vendor.limit }}
                    of
                    {{ vendor.total }}
                    entries
                  </div>
                </b-row>
              </b-col>
              <b-col cols="6">
                <b-pagination
                  align="right"
                  :total-rows="vendor.total"
                  :per-page="vendor.limit"
                  v-model="vendor.page"
                ></b-pagination>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </b-form>
      <b-row class="justify-content-center mb-2">
        <button
          v-if="saveEnabled"
          class="btn btn-primary mr-1"
          @click.stop="save()"
        >
          <i class="fa fa-save"></i> Save
        </button>
        <b-button class="btn btn-primary mr-1" @click.stop="close()">
          <i class="fa fa-close"></i> Close</b-button
        >
      </b-row>
    </b-card>
    <b-modal
      v-model="lkuVendorShow"
      size="lg"
      :hide-footer="true"
      title="List of Vendor"
      :centered="true"
    >
      <lku-supplier @click="onSelectLkuVendor"></lku-supplier>
    </b-modal>
  </div>
</template>

<script>
import item from "../../apis/bakeryitem";
import { validationMixin } from "vuelidate";
import { required, requiredIf, numeric } from "vuelidate/lib/validators";
import myNumber from "../../components/my-number";
import lkuSupplier from "../lookup/lkuSupplier";
import dropdown from "../../data/dropdown";
import toastr from "mini-toastr";
import crud from "../../apis/crud";
toastr.init();

export default {
  components: { myNumber, lkuSupplier },
  mixins: [validationMixin],
  validations: {
    model: {
      itemname: { required },
      invunitom: { required: requiredIf("inventory") },
      unitsize: { required },
      itemcategory: { required },
    },
    vendor: {
      obj: {
        itemno: { required },
        kodevendor: { required },
      },
    },
  },
  data() {
    return {
      saveEnabled: true,
      dataList: {
        YesNo: dropdown.YesNo,
      },
      itemCategories: [
        { text: '-- All --', value: '' }
      ],
      model: {
        itemno: "",
        partnumber: "",
        itemname: "",
        itemcategory: "EXP 4 DAYS",
        headcategory: "BREAD",
        inventory: "0",
        qtykonversi: 1,
        invunitom: "UNIT",
        unitsize: "UNIT",
        compcode: this.$store.state.user.compcode,
      },

      vendor: {
        list: [],
        obj: { kodevendor: "", itemno: "" },
        fields: [
          { key: "index", label: "No.", thStyle: "width:40px" },
          {
            key: "vendorinfo",
            label: "Vendor/Supplier Name",
          },
          {
            key: "alamat",
            label: "Address",
          },
          {
            key: "kota",
            label: "City",
          },
          {
            key: "telepon",
            label: "Phone",
          },
          {
            key: "action",
            label: "Action",
            thStyle: "width:60px",
            thClass: "text-center",
          },
        ],
        page: 1,
        limit: 6,
        total: 0,
      },
      lkuVendorShow: false,
      currency: [{ value: "IDR", text: "IDR" }],
      headCategories: [],
    };
  },
  computed: {
    invalidModel() {
      this.$v.model.$touch();
      return this.$v.model.$invalid;
    },
    inventory() {
      return this.model.inventory;
    },
  },
  created: async function () {
    // const itemCat = await crud.list({
    //   tablename:'itemcategory',
    //     page: 1,
    //     limit: 15,
    //     total: 0,
    //     sortBy: 'nama',
    //     sortDesc: true
    // });
    // this.itemCategories =itemCat.reduce((arr=[],obj,idx)=>{
    //     arr.push({ value: obj.kode, text: obj.nama });
    //     return arr;
    // },[]);

    const [itemCategories] = await Promise.all([
        item.group()
        ]) ;
    if(itemCategories){
          itemCategories.map((data)=>{
            this.itemCategories.push({
                value:data.nama,
                text:data.nama
            });
        });
    }

    if (this.$route.params.itemno) {
      toastr.info("Loading Item Detail, please wait");
      try {
        // const data = await item.detail(this.$route.params);
        const data = await item.detail(this.$route.params);
        const row = data[0];
        for (var key in row) {
          this.model[key] = row[key];
        }
        this.vendor.list = data[1];
        this.$forceUpdate();
        toastr.clear;
      } catch (error) {
        console.log("error : ", error);
        toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
      }
    }
  },
  methods: {
    addGroup: function () {
      this.lkuGroupShow = true;
    },
    delGroup: function (index) {
      if (index > -1) {
        this.group.list.splice(index, 1);
      }
      this.group.total = this.group.list.length;
    },
    addVendor: function () {
      this.lkuVendorShow = true;
    },
    delVendor: function (index) {
      if (index > -1) {
        this.vendor.list.splice(index, 1);
      }
      this.vendor.total = this.vendor.list.length;
    },
    onSelectLkuGroup: function (_selected) {
      const obj = {
        idgroup: _selected.idgroup,
        kodegroup: _selected.kodegroup,
        namagroup: _selected.namagroup,
      };
      this.group.list.push(obj);
      this.group.total = this.group.list.length;
      this.lkuGroupShow = false;
    },
    onSelectLkuVendor: function (_selected) {
      const obj = {
        vendorinfo:
          _selected.vendor_code.trim() + " | " + _selected.vendor_name.trim(),
        kodevendor: _selected.vendor_code,
        alamat: _selected.vendor_address1,
        kota: _selected.vendor_city,
        telepon: _selected.vendor_phone,
        idvendor: _selected.vendor_id,
      };
      this.vendor.list.push(obj);
      this.vendor.total = this.vendor.list.length;
      // console.log('this.vendor.list : ',this.vendor.list);
      // this.$refs.tblVendor.refresh();
      this.lkuVendorShow = false;
    },

    save: async function () {
      if (!this.saveEnabled) {
        return;
      }
      this.saveEnabled = false;
      // this.model.npwp_name = this.model.npwp_name || this.model.itemname;
      // this.model.npwp_address1 = this.model.npwp_address1 || this.model.item_address1 ;
      // this.model.npwp_address2 = this.model.npwp_address2 || this.model.item_address2;
      // this.model.npwp_city = this.model.npwp_city || this.model.item_city;
      // console.log("#this.model: ", this.model);
      // console.log("#this.vendor: ", this.vendor.list.length);
      if (this.invalidModel) {
        console.log("validation  : ", this.$v.model);
        //console.log("model : ", this.model);
        toastr.error("Please fill the form correctly.", "ERROR MESSAGE");
        this.saveEnabled = true;
      } else {
        if (this.vendor.list.length === 0) {
          toastr.error(
            "Please add supplier/vendor for this item first!",
            "ERROR MESSAGE"
          );
          this.saveEnabled = true;
        } else {
          try {
            const data = {};
            for (var key in this.model) {
              data[key] = this.model[key];
            }
            data.vendors = this.vendor.list.reduce((newArr, item) => {
              newArr.push(item);
              return newArr;
            }, []);
            await item.save(data);
            this.close();
          } catch (error) {
            this.saveEnabled = true;
            if (error.message) {
              toastr.error(error.message, "ERROR MESSAGE", 10000);
            } else {
              toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
            }
          }
        }
      }
    },
    close() {
      if (
        this.$store.state.prevRoute.name &&
        this.$store.state.prevRoute.name !== "bakery.itemfrm"
      ) {
        router.push({ name: this.$store.state.prevRoute.name });
      } else {
        router.push({ name: "bakery.item" });
      }
    },
  },
};
</script>